import request from '@/utils/request'

// 获取视频播放凭证
export function getVideoPlayAuth(id) {
    return request({
        url: '/hdjg/vod/getVideoPlayAuth/2?id=' + id,
        method: 'get'
    })
}

// 获取视频播放地址
export function getVideoPlayPath(id) {
    return request({
        url: '/hdjg/vod/getPlayInfo/2?id=' + id,
        method: 'get'
    })
}

// 获取课程的vod资源
export function getVodResource(id) {
    return request({
        url: '/hdjg/vod/getVodResource?id=' + id,
        method: 'get'
    })
}

// 保存进度
export function saveProgress(data) {
    return request({
        url: '/hdjg/vod/save/progress',
        method: 'post',
        data: data
    })
}

// 获取进度
export function getProgress(classId, courseId, chapterId) {
    return request({
        url: '/hdjg/vod/get/progress?classId=' + classId + '&courseId=' + courseId + '&chapterId=' + chapterId,
        method: 'get'
    })
}